// extracted by mini-css-extract-plugin
export default {"wrapperBig":"egedA","wrapperMedium":"Lxrxs","grid":"uZIBX"};